import { render, staticRenderFns } from "./LangSet.vue?vue&type=template&id=442401bf&scoped=true"
import script from "./LangSet.vue?vue&type=script&lang=js"
export * from "./LangSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442401bf",
  null
  
)

export default component.exports